exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{margin:0;padding:0;font-size:14px;background:#fafffa}.notice{margin:20px auto;padding:15px 0;text-align:center;border:1px solid #000;border-width:1px 0;background:#666}.inline-block{display:inline-block}.with-line-breaks{white-space:pre-line}.DayPickerInput-Overlay{z-index:99}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/app.css
// module id = 466
// module chunks = 0